"use client"
import { sendMessage } from 'api/MessageApi'
import { Button } from 'components/commons/Button'
import Input from 'components/commons/Input'
import InputArea from 'components/commons/InputArea'
import { Formik } from 'formik'
import { useTranslations } from 'next-intl'
import { useState } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import * as Yup from 'yup'

const ContactUsForm = () => {
  const t = useTranslations('contatos')

  const [sent, setSent] = useState(false)
  const [error, setError] = useState(false)

  const { executeRecaptcha } = useGoogleReCaptcha()

  return (
    <Formik
      initialValues={{
        name: '',
        email: '',
        phoneNumber: '',
        message: ''
      }}
      validationSchema={Yup.object().shape({
        name: Yup.string().required().max(100),
        email: Yup.string().email().max(50).required(),
        phoneNumber: Yup.string().max(20),
        message: Yup.string().min(1).max(500).required()
      })}
      onSubmit={async value => {
        setError(false)
        setSent(false)
        const token = await executeRecaptcha('contactUs')
        await sendMessage(
          {
            name: value.name,
            email: value.email,
            phoneNumber: value.phoneNumber,
            message: value.message
          },
          token
        )
          .then(() => setSent(true))
          .catch(() => {
            setError(true)
            setSent(false)
          })
      }}
    >
      {({
        handleChange,
        handleSubmit,
        isSubmitting,
        values,
      }) => (
        <form onSubmit={handleSubmit}>
          <div className='grid gap-5 lg:grid-cols-2'>
            <div className='lg:col-span-2'>
              <Input
                id='name'
                name='name'
                label={t('name')}
                variant='primary'
                onChange={handleChange}
                disabled={isSubmitting || sent}
                value={values.name}
              />
            </div>
            <div className='lg:col-span-1'>
              <Input
                id='email'
                name='email'
                type='email'
                label={t('email')}
                variant='primary'
                onChange={handleChange}
                disabled={isSubmitting || sent}
                value={values.email}
              />
            </div>
            <div className='lg:col-span-1'>
              <Input
                id='phoneNumber'
                name='phoneNumber'
                label={t('phoneNumber')}
                variant='primary'
                onChange={handleChange}
                disabled={isSubmitting || sent}
                value={values.phoneNumber}
              />
            </div>
            <div className='lg:col-span-2'>
              <InputArea
                id='message'
                name='message'
                label={t('message')}
                variant='primary'
                onChange={handleChange}
                disabled={isSubmitting || sent}
                value={values.message}
              />
            </div>
            <div className='lg:col-span-2'>
              <Button
                id='submit'
                name='submit'
                type='submit'
                variant='primary'
                disabled={isSubmitting || sent}
                submitted={sent}
                isSubmitting={isSubmitting}
                className='w-full'
                text={!sent ? t('sendMessage') : t('sentMessage')}
              />
            </div>
          </div>
          <div className='mt-4 text-sm lg:col-span-2'>
            <div>
              {error && t('error')}
            </div>
          </div>
        </form>
      )}
    </Formik>
  )
}

export default ContactUsForm
